import { ChangeEvent, Fragment, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import BreadCrumbs from "../../../components/breadcrumbs/Breadcrumbs";
import ConfirmationDialog from "../../../components/confirmation-dialog/ConfirmationDialog";
import Container from "@mui/material/Container";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import MediaAssets from "../../../assets";
import MenuItem from "@mui/material/MenuItem";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import NoDataRecord from "../../../components/no-data-record/NoDataRecord";
import PageHeading from "../../../components/page-heading/PageHeading";
import Paper from "@mui/material/Paper";
import { RouteConstants } from "../../../routes/RouteConstants";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
  Avatar,
  Checkbox,
  ClickAwayListener,
  Stack,
  Typography,
  Popper,
} from "@mui/material";
import PrioritySelector from "components/ui-elements/priority-selector/PrioritySelector";
import {
  AutocompleteComponent,
  SwitchComponent,
  TextFieldComponent,
} from "components/ui-elements";
import { InfoOutlined } from "@mui/icons-material";
import styles from "./BlogList.module.css";
import {
  BlogActionTypeEnum,
  BlogActionTypeEnumUtils,
} from "enumerations/ActionTypeEnum";
import BlogActions from "../../../redux-container/blog-management/BlogRedux";

import { useDispatch, useSelector } from "react-redux";
import { exportAsExcel } from "utils/ExportFileUtils";
import {
  StatusTypeEnumInsight,
  BlogStatusTypeEnum,
  BlogStatusTypeEnumUtils,
} from "enumerations/StatusTypeEnum";
import Loader from "components/loader/Loader";
import Retry from "components/retry/Retry";
import FlashMessageDialog from "components/flash-message-dialog/FlashMessageDialog";
import { UpdateTypeEnum, UpdateTypeValueEnum } from "./BlogListConstants";
import UserActions from "redux-container/users/UsersRedux";
import { ReadmoreDialogWrapper } from "pages/promise-management/promise-list/PromiseList";
import { AuditActions } from "redux-container/audit-log/auditLogRedux";
import { RoleAndModuleActions } from "redux-container/users/RolesAndModulesRedux";
import { AuditStatus } from "enumerations/AuditStatusTypes";
import { format } from "date-fns";

const actionDispatch = (dispatch: any) => {
  return {
    getBlogs: (params: any) => dispatch(BlogActions.blogRequest(params)),
    deleteBlog: (data: any) => dispatch(BlogActions.deleteBlogRequest(data)),
    bulkBlogDelete: (data: any) =>
      dispatch(BlogActions.deleteBulkBlogRequest(data)),
    blogStatus: (data: any) => dispatch(BlogActions.blogStatusRequest(data)),
    blogPriority: (data: any) =>
      dispatch(BlogActions.blogPriorityRequest(data)),
    setBlogState: (key: any, data: any) => {
      dispatch(BlogActions.setBlogState(key, data));
    },
    getUsers: (params: any) =>
      dispatch(UserActions.getUsersListRequest(params)),

    postAuditLogRequest: (data: any) =>
      dispatch(AuditActions.postAuditLogRequest(data)),
    rolesAndModulesRequest: () =>
      dispatch(RoleAndModuleActions.rolesAndModulesRequest()),
  };
};

const BlogList = () => {
  const listData = useSelector((state: any) => state);
  const isLoading = useSelector((state: any) => state.blogDashboard?.isLoading);
  const isPriorityUpdated = useSelector(
    (state: any) => state.blogDashboard?.isPriorityUpdated
  );
  const error = useSelector((state: any) => state.blogDashboard?.error);
  const isSuccess: any = useSelector(
    (state: any) => state?.blogDashboard?.isDeleted
  );
  const message = useSelector((state: any) => state.blogDashboard?.message);
  const updateData = useSelector((state: any) => state?.blogDashboard);
  const updatesListData = useSelector(
    (state: any) => state?.blogDashboard.updates
  );
  const totalCount = useSelector(
    (state: any) => state?.blogDashboard.totalCount
  );
  const users = useSelector((state: any) => state?.users.usersForFilters);
  const shouldOpenFlashDialog: any = useSelector(
    (state: any) => state?.update?.shouldOpenFlashDialog
  );
  const { page, rowsPerPage, modules } = useSelector((state: any) => {
    return {
      page: state?.blogDashboard?.page,
      rowsPerPage: state?.blogDashboard?.rowsPerPage,
      modules: state?.rolesAndModules?.module,
    };
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location: any = useLocation();

  const actionsData = BlogActionTypeEnumUtils.getBlogActionTypeEnum();
  const [selectedAction, setSelectedAction] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedFormType, setSelectedFormType] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedUpdate, setSelectedUpdate] = useState<any>([]);
  const [selectedModifiedUser, setSelectedModifiedUser] = useState("");

  const [isConfirmDeleteDialogOpen, setIsConfirmDeleteDialogOpen] =
    useState(false);
  const [priority, setPriority] = useState(1);
  const [selectedCreatedBy, setSelectedCreatedBy] = useState<any>(null);
  const [selectedUpdatedBy, setSelectedUpdatedBy] = useState<any>(null);
  const [selectPublishedBy, setSelectPublishedBy] = useState("");
  const [createdBy, setcreatedBy] = useState(1);
  const [isSortByPriority, setSortByPriority] = useState(true);
  const [anchor, setAnchor] = useState(null);
  const [description, setDescription] = useState("");
  const [open, setOpen] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [sortingPriority, setSortingPriority] = useState(0);
  const [sortingKey, setSortingKey] = useState(1);
  const [isCreatedBySort, setCreatedBySort] = useState(true);
  const [isPublishedBySort, setPublishedBySort] = useState(true);
  const [isModifiedBySort, setModifiedBySort] = useState(true);
  const [isStatusUpdate, setIsStatusUpdate] = useState<any>();

  const [modulesAudited, setModulesAudited] = useState<any>(null);
  const ipAddress = useSelector((state: any) => state?.auditLog?.ipAddress);

  const statuses = BlogStatusTypeEnumUtils.getBlogStatusTypeEnums();
  const breadcrumbRoutes: any = [
    {
      name: "Blog Management",
      route: RouteConstants.blogManagementDashboard,
    },
    {
      name: "Blogs",
      route: RouteConstants.blogs,
    },
  ];

  const {
    getBlogs,
    deleteBlog,
    setBlogState,
    blogStatus,
    blogPriority,
    getUsers,
    rolesAndModulesRequest,
    postAuditLogRequest,
  } = actionDispatch(useDispatch());

  useEffect(() => {
    getFilterDataFromDashboard();
    const params = {
      index: page + 1,
      size: rowsPerPage,
      type: selectedType,
      action: selectedAction,
      status: location?.state?.statusType
        ? location?.state?.statusType
        : selectedStatus,
      updateType: selectedFormType,
      createdBy:
        selectedCreatedBy?.id !== undefined ? selectedCreatedBy?.id : "",
      updatedBy:
        selectedUpdatedBy?.id !== undefined ? selectedUpdatedBy?.id : "",
      publishedBy: selectPublishedBy,
      byPrority: isSortByPriority,
      searchKey: searchKey,
      sortingKey: sortingKey,
      sortingPriority: sortingPriority,
    };
    getBlogs(params);
    setSelectedAction("");
    setSelectedUpdate([]);
    // getUsers({});
  }, [
    dispatch,
    rowsPerPage,
    // selectedAction,
    // isLoading,
    message,

    selectedFormType,
    page,
    selectedCreatedBy,
    selectedUpdatedBy,
    selectPublishedBy,
    // priority,
    createdBy,
    selectedType,
    selectedStatus,
    isSortByPriority,
    searchKey,
    sortingKey,
    sortingPriority,
    isStatusUpdate,
    // isConfirmDeleteDialogOpen,
  ]);
  useEffect(() => {
    if (isPriorityUpdated) {
      setBlogState("isPriorityUpdated", false);
      const params = {
        index: page + 1,
        size: rowsPerPage,
        type: selectedType,
        action: selectedAction,
        status: location?.state?.statusType
          ? location?.state?.statusType
          : selectedStatus,
        updateType: selectedFormType,
        createdBy:
          selectedCreatedBy?.id !== undefined ? selectedCreatedBy?.id : "",
        updatedBy:
          selectedUpdatedBy?.id !== undefined ? selectedUpdatedBy?.id : "",
        publishedBy: selectPublishedBy,
        byPrority: isSortByPriority,
        searchKey: searchKey,
        sortingKey: sortingKey,
        sortingPriority: sortingPriority,
      };
      getBlogs(params);
      setSelectedAction("");
      setSelectedUpdate([]);
    }
  }, [isPriorityUpdated]);

  useEffect(() => {
    if (location.state?.isNavigationFromSidemenu) {
      setBlogState("page", 0);
      setBlogState("rowsPerPage", 10);
    }

    return () => {};
  }, []);

  useEffect(() => {
    rolesAndModulesRequest();
    return () => {};
  }, []);

  const tableHeadings = [
    { heading: "Blog" },
    { heading: "Type" },
    { heading: "Created On" },
    { heading: "Published On" },
    { heading: "Modified On" },
    { heading: "Last Modified By" },
    { heading: "Priority" },
    { heading: "Status" },
    { heading: "Actions" },
  ];

  const getFilterDataFromDashboard = () => {
    if (location && location.state && location.state.statusType) {
      setSelectedStatus(location.state.statusType as string);
    }
    navigate(location.pathname, { replace: true });
  };

  const handleCloseConfirmDialog = () => {
    setIsConfirmDeleteDialogOpen(false);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setBlogState("page", newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setBlogState("rowsPerPage", Number(event.target.value));
    setBlogState("page", 0);
  };

  const renderLoader = () => {
    return <Loader />;
  };
  const renderRetry = () => {
    return <Retry message={"Error"} retryHandler={() => loadData({})} />;
  };
  const loadData = (params: any) => {
    getBlogs(params);
  };

  const handleActionChange = (event: SelectChangeEvent) => {
    // setSelectedAction(event.target.value as string);
    const actionSelected = event.target.value;

    switch (Number(actionSelected)) {
      case BlogActionTypeEnum.Export:
        handleExportAsExcel();
        break;
      case BlogActionTypeEnum.Delete:
        handleDelete();
        break;
      case BlogActionTypeEnum.MarkAsPublished:
        changeUpdateStatus(String(BlogStatusTypeEnum.Published));
        break;
      case BlogActionTypeEnum.MarkAsInactive:
        changeUpdateStatus(String(BlogStatusTypeEnum.Inactive));
        break;
    }
  };

  const handleCloseFlashMessageDialog = () => {
    setBlogState("error", null);
    setBlogState("message", null);

    const moduleObject: any = modules?.find((element: any) => {
      return element?.name === "Blog Management";
    });
    const postAuditRequestbody = {
      ipAddress: ipAddress, //ipAddress
      moduleId: moduleObject?.id,
      route: null,
      auditedObject: null,
      modulesAudited: modulesAudited,
      status: null,
    };
    postAuditLogRequest(postAuditRequestbody);
  };

  const handleStatusChange = (event: SelectChangeEvent) => {
    setSelectedStatus(event.target.value as string);
    if (page !== 0) {
      setBlogState("page", 0);
    }
  };

  const changeUpdateStatus = (status: any) => {
    const data = {
      status: status,
      marketingUpdateIds: selectedUpdate,
    };

    if (selectedUpdate.length === 0) {
      alert("You have not selected any blogs");
      return;
    }

    let auditedItems = statusAuditedItems();
    let auditObjectsArray: any[] = [];
    auditedItems?.map((item: any) => {
      let auditObject = {
        itemAffected: `Update Status`,
        newValue:
          BlogStatusTypeEnum.Published === status ? "Published" : "Inactive",
        oldValue:
          BlogStatusTypeEnum.Published === status ? "Inactive" : "Published",
        auditedObject: { data: { ...item, status: status }, isEditMode: true },
        route: RouteConstants?.updateCreation,
        status: AuditStatus.EDITED,
      };
      auditObjectsArray.push(auditObject);
    });
    setModulesAudited(auditObjectsArray);

    // clearSelected();
    blogStatus(data);
    setIsStatusUpdate(data);
  };

  const handleDelete = () => {
    if (selectedUpdate.length === 0) {
      alert("You have not selected any updates");
      return;
    }
    setIsConfirmDeleteDialogOpen(true);
  };

  const statusAuditedItems = () => {
    let auditedItems: any[] = [];
    updatesListData?.map((item: any) => {
      selectedUpdate?.map((itemId: number) => {
        if (itemId === item.id) {
          auditedItems.push(item);
        }
      });
    });
    return auditedItems;
  };
  const deleteSelectedUpdates = () => {
    const updates = {
      marketingUpdateIds: [...selectedUpdate],
    };

    let auditedItems = statusAuditedItems();
    let auditObjectsArray: any[] = [];
    auditedItems?.map((item: any) => {
      let auditObject = {
        itemAffected: `Update ${item?.displayTitle} Deleted.(ID${item?.id})`,
        newValue: "",
        oldValue: "",
        auditedObject: null,
        route: null,
        status: AuditStatus.DELETED,
      };
      auditObjectsArray.push(auditObject);
    });
    setModulesAudited(auditObjectsArray);

    deleteBlog(updates);
    setIsConfirmDeleteDialogOpen(false);
  };

  const handleExportAsExcel = () => {
    let formattedExcelData: any[] = [];

    if (selectedUpdate.length > 0) {
      const selectedRowsData = updatesListData.filter((obj: any) =>
        selectedUpdate.includes(obj.id)
      );
      formattedExcelData = selectedRowsData.map((obj: any) => {
        return {
          id: obj.id,
          Blog: obj.displayTitle,
          Type:
            obj.updateType === UpdateTypeValueEnum.HoABL
              ? UpdateTypeEnum.HoABL
              : obj.updateType === UpdateTypeValueEnum.Project
              ? UpdateTypeEnum.Project
              : UpdateTypeEnum.Factual,
          CreatedAt: obj.createdAt
            ? format(new Date(obj.createdAt), "dd/MM/yyyy")
            : null,
          PublishedAt: obj.createdAt
            ? format(new Date(obj.createdAt), "dd/MM/yyyy")
            : null,
          UpdatedAt: obj.updatedAt
            ? format(new Date(obj?.updatedAt), "dd/MM/yyyy")
            : null,
          MarketingUpdateUpdatedBy: obj?.marketingUpdateUpdatedBy?.firstName
            ? obj?.marketingUpdateUpdatedBy?.firstName
            : null,
          MarketingUpdateCreatedBy: obj?.marketingUpdateCreatedBy?.firstName
            ? obj?.marketingUpdateCreatedBy?.firstName
            : null,
          Priority: obj.priority,
          Status: obj?.status
            ? BlogStatusTypeEnumUtils.getEnumText(obj?.status)
            : "-",
        };
      });
    } else {
      // formattedExcelData = updatesListData.map((obj: any) => {
      //   return {
      //     id: obj.id,
      //     Blog: obj.displayTitle,
      //     Type:
      //       obj.updateType === UpdateTypeValueEnum.HoABL
      //         ? UpdateTypeEnum.HoABL
      //         : obj.updateType === UpdateTypeValueEnum.Project
      //         ? UpdateTypeEnum.Project
      //         : UpdateTypeEnum.Factual,
      //     CreatedAt: obj.createdAt
      //       ? format(new Date(obj.createdAt), "dd/MM/yyyy")
      //       : null,
      //     PublishedAt: obj.createdAt
      //       ? format(new Date(obj.createdAt), "dd/MM/yyyy")
      //       : null,
      //     UpdatedAt: obj.updatedAt
      //       ? format(new Date(obj?.updatedAt), "dd/MM/yyyy")
      //       : null,
      //     MarketingUpdateUpdatedBy: obj?.marketingUpdateUpdatedBy?.firstName
      //       ? obj?.marketingUpdateUpdatedBy?.firstName
      //       : null,
      //     MarketingUpdateCreatedBy: obj?.marketingUpdateCreatedBy?.firstName
      //       ? obj?.marketingUpdateCreatedBy?.firstName
      //       : null,
      //     Priority: obj.priority,
      //     Status: obj?.status
      //       ? BlogStatusTypeEnumUtils.getEnumText(obj?.status)
      //       : "-",
      //   };
      // });
      alert("Please select blogs to export !");
      return;
    }
    exportAsExcel(formattedExcelData, "Blogs", "Sheet1");
  };

  const handleFormTypeChange = (event: SelectChangeEvent) => {
    setSelectedFormType(event.target.value as string);
    if (page !== 0) {
      setBlogState("page", 0);
    }
  };

  // const handleCreatedByChange = (event: SelectChangeEvent) => {
  //   setSelectedCreatedBy(event.target.value as string);
  // };
  const handleUpdatedByChange = (event: SelectChangeEvent) => {
    setSelectedUpdatedBy(event.target.value as string);
  };

  const handlePublishedByChange = (event: SelectChangeEvent) => {
    setSelectPublishedBy(event.target.value as string);
  };

  const createUpdate = () => {
    navigate(RouteConstants.blogCreation);
  };

  const handleClick = (event: React.MouseEvent<unknown>, id: any) => {
    const selectedIndex = selectedUpdate.indexOf(id);
    let newSelected: readonly string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedUpdate, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedUpdate.slice(1));
    } else if (selectedIndex === selectedUpdate.length - 1) {
      newSelected = newSelected.concat(selectedUpdate.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedUpdate.slice(0, selectedIndex),
        selectedUpdate.slice(selectedIndex + 1)
      );
    }
    setSelectedUpdate(newSelected);
  };

  const isSelected = (id: any) => selectedUpdate.indexOf(id) !== -1;

  const clearSelected = () => {
    setSelectedUpdate([]);
  };

  const handleSelectAllClick = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = updatesListData.map((n: any) => n.id);
      setSelectedUpdate(newSelecteds);
      return;
    }
    setSelectedUpdate([]);
  };

  const handleChangePrioritySwitchButton = () => {
    setSortByPriority(!isSortByPriority);
  };

  const editUpdate = (data: any) => {
    console.log("edit", data)
    navigate(RouteConstants.blogCreation, {
      state: { data: data, isEditMode: true },
    });
  };

  const viewUpdate = (data: any) => {
    navigate(RouteConstants.blogCreation, {
      state: { data: data, isDisabled: true },
    });
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  const popOverComponent = (event: any, description: any) => {
    setAnchor(event.currentTarget);
    setOpen(!open);
    setDescription(description);
  };

  const clearFilters = () => {
    setSelectedStatus("");
    setSelectedCreatedBy(null);
    setSelectedFormType("");
    setSelectPublishedBy("");
    setSelectedUpdatedBy(null);
  };

  const handleSearchChange = (searchKey: string) => {
    setSearchKey(searchKey);
    if (page !== 0) {
      setBlogState("page", 0);
    }
  };

  const renderNoData = () => {
    return (
      <NoDataRecord
        image={MediaAssets.ic_newspaper}
        altText=""
        message="You haven't created any Blogs yet. Create your first Blog."
        btnTitle="CREATE BLOGS"
        btnAction={createUpdate}
      />
    );
  };

  const renderTable = () => {
    return (
      <Fragment>
        <div className="heading-action-holder">
          <h4 className="heading">
            Blogs List
            {`(${
              totalCount
                ? totalCount
                : updatesListData?.length
                ? updatesListData?.length
                : 0
            })`}
            {selectedUpdate?.length > 0 ? (
              <Fragment>
                <span className="selected-items-count-text">
                  {`${selectedUpdate.length} blog(s) Selected`}
                </span>
                <a className="clear-selected-text" onClick={clearSelected}>
                  Clear
                </a>
              </Fragment>
            ) : null}
          </h4>

          <div>
            <FormControl className="action-dropdown">
              <TextFieldComponent
                select
                value={selectedAction}
                label="Action"
                onChange={handleActionChange}
              >
                {actionsData.map((action: any) => {
                  return (
                    <MenuItem value={action.value}>{action.label}</MenuItem>
                  );
                })}
              </TextFieldComponent>
            </FormControl>

            <Button
              variant="contained"
              onClick={createUpdate}
              // autoFocus
              disableElevation
              className="btn btn-dark"
            >
              Create New
            </Button>
          </div>
        </div>

        <Stack>
          <Grid container spacing={1}>
            <Grid container spacing={1} md={8} lg={8} xl={8}>
              <Grid
                item
                md={1}
                lg={1}
                xl={1}
                className="margin-left-10 filter-heading-holder"
              >
                <span className="filter-heading">Filters:</span>
              </Grid>

              <Grid item md={2} lg={2} xl={2}>
                <FormControl className="filter-dropdown">
                  <TextFieldComponent
                    select
                    value={selectedStatus}
                    label="Status"
                    onChange={handleStatusChange}
                  >
                    {statuses.map((status: any) => {
                      return (
                        <MenuItem value={status.value} key={status.value}>
                          {status.label}
                        </MenuItem>
                      );
                    })}
                  </TextFieldComponent>
                </FormControl>
              </Grid>

              <Grid item md={2} lg={2} xl={2}>
                <FormControl className="filter-dropdown">
                  <TextFieldComponent
                    select
                    value={selectedFormType}
                    label="Type"
                    onChange={handleFormTypeChange}
                  >
                    <MenuItem value={UpdateTypeValueEnum.HoABL}>HoABL</MenuItem>
                    <MenuItem value={UpdateTypeValueEnum.Project}>
                      Project
                    </MenuItem>
                    <MenuItem value={UpdateTypeValueEnum.Factual}>
                      Factual
                    </MenuItem>
                  </TextFieldComponent>
                </FormControl>
              </Grid>

              <Grid item md={3} lg={3} xl={3}>
                <FormControl className="filter-dropdown">
                  <AutocompleteComponent
                    options={users}
                    getOptionLabel={(option: any) =>
                      option?.isDuplicated
                        ? `${option?.firstName} ${option?.lastName} (#-${option?.id})`
                        : `${option?.firstName} ${option?.lastName}`
                    }
                    label="Created By"
                    onChange={(
                      event: React.SyntheticEvent,
                      newValue: any | null
                    ) => {
                      setSelectedCreatedBy(newValue);
                      if (page !== 0) {
                        setBlogState("page", 0);
                      }
                    }}
                    value={selectedCreatedBy}
                    isOptionEqualToValue={(option: any, value: any) =>
                      option?.id === value?.id
                    }
                  />
                </FormControl>
              </Grid>

              <Grid item md={3} lg={3} xl={3}>
                <FormControl className="filter-dropdown">
                  <AutocompleteComponent
                    options={users}
                    getOptionLabel={(option: any) =>
                      option?.isDuplicated
                        ? `${option?.firstName} ${option?.lastName} (#-${option?.id})`
                        : `${option?.firstName} ${option?.lastName}`
                    }
                    label="Modified By"
                    onChange={(
                      event: React.SyntheticEvent,
                      newValue: any | null
                    ) => {
                      setSelectedUpdatedBy(newValue);
                      if (page !== 0) {
                        setBlogState("page", 0);
                      }
                    }}
                    value={selectedUpdatedBy}
                    isOptionEqualToValue={(option: any, value: any) =>
                      option?.id === value?.id
                    }
                  />
                </FormControl>
              </Grid>

              {/* <Grid item md={2} lg={2} xl={2}>
                <FormControl className="filter-dropdown">
                  <TextFieldComponent
                    select
                    value={selectPublishedBy}
                    label="Published By"
                    onChange={handlePublishedByChange}
                  >
                    {users.map((user: any) => {
                      return (
                        <MenuItem value={user.id} key={user.value}>
                          {user.firstName}
                        </MenuItem>
                      );
                    })}
                  </TextFieldComponent>
                </FormControl>
              </Grid> */}
              {selectedStatus !== "" ||
              selectedUpdatedBy !== null ||
              selectedCreatedBy !== null ||
              selectPublishedBy != "" ||
              selectedFormType != "" ? (
                <Grid
                  item
                  md={0.5}
                  lg={0.5}
                  xl={0.5}
                  className="filter-heading-holder"
                  style={{ position: "relative" }}
                >
                  <span
                    onClick={clearFilters}
                    className="clear-filter"
                    style={{ position: "absolute", top: 32 }}
                  >
                    Clear
                  </span>
                </Grid>
              ) : null}
            </Grid>
          </Grid>

          <div className="time-sync-holder margin-right-15">
            <p className={styles["priority-switch-btn-alignment"]}>
              Sort by Priority
            </p>
            <SwitchComponent
              checked={isSortByPriority}
              onChange={handleChangePrioritySwitchButton}
            />
            <Tooltip
              arrow
              placement="top-start"
              title="Disabling the toggle will switch to show items on the Customer App based on Date & Time."
            >
              <InfoOutlined className={styles["infooutlined-alignment"]} />
            </Tooltip>
          </div>
        </Stack>
        <TableContainer
          component={Paper}
          className="table-container"
          style={{ height: window.innerHeight - 475 }}
        >
          <Table style={{ position: "relative" }}>
            <TableHead>
              <TableRow className="table-header-row">
                <TableCell
                  style={{ minWidth: 50 }}
                  className="table-header-text"
                  padding="checkbox"
                >
                  <Checkbox
                    className="active-checkbox"
                    indeterminate={
                      selectedUpdate?.length > 0 &&
                      selectedUpdate?.length < updatesListData?.length
                    }
                    checked={
                      updatesListData?.length > 0 &&
                      selectedUpdate?.length === updatesListData?.length
                    }
                    onChange={handleSelectAllClick}
                    inputProps={{
                      "aria-label": "select all promotions and offers",
                    }}
                  />
                </TableCell>
                {tableHeadings.map((item, index) => (
                  <TableCell key={index} className="table-header-text">
                    {item.heading}

                    {/* {index === 2 && (
                      <IconButton
                        onClick={() => {
                          setCreatedBySort(!isCreatedBySort);
                          if (sortingPriority === 0) {
                            setSortingKey(0);
                            setSortingPriority(1);
                            setSortByPriority(false);
                          } else {
                            setSortingPriority(0);
                            setSortingKey(0);
                            setSortByPriority(false);
                          }
                        }}
                      >
                        {isCreatedBySort ? (
                          <ArrowDropDownIcon />
                        ) : (
                          <ArrowDropUpIcon />
                        )}
                      </IconButton>
                    )} */}
                    {/* {index === 3 && (
                      <IconButton
                        onClick={() => {
                          setPublishedBySort(!isPublishedBySort);
                          if (sortingPriority === 0) {
                            setSortingKey(0);
                            setSortingPriority(1);
                            setSortByPriority(false);
                          } else {
                            setSortingPriority(0);
                            setSortingKey(0);
                            setSortByPriority(false);
                          }
                        }}
                      >
                        {isPublishedBySort ? (
                          <ArrowDropDownIcon />
                        ) : (
                          <ArrowDropUpIcon />
                        )}
                      </IconButton>
                    )}
                    {index === 4 && (
                      <IconButton
                        onClick={() => {
                          setModifiedBySort(!isModifiedBySort);
                          if (sortingPriority === 0) {
                            setSortingKey(1);
                            setSortingPriority(1);
                            setSortByPriority(false);
                          } else {
                            setSortingPriority(0);
                            setSortingKey(1);
                            setSortByPriority(false);
                          }
                        }}
                      >
                        {isModifiedBySort ? (
                          <ArrowDropDownIcon />
                        ) : (
                          <ArrowDropUpIcon />
                        )}
                      </IconButton>
                    )} */}
                    {index == 6 && (
                      <IconButton>
                        <Tooltip
                          title={
                            "The items will be shown in ascending order of the priority number on the Customer App."
                          }
                          placement="top-start"
                        >
                          <Avatar
                            sx={{
                              width: "0.9rem",
                              height: "0.9rem",
                              cursor: "pointer",
                              marginTop: "0.10rem",
                              marginBottom: "0.10rem",
                            }}
                            src={MediaAssets.ic_info}
                            variant="rounded"
                          />
                        </Tooltip>
                      </IconButton>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {updatesListData && updatesListData.length > 0 ? (
              <TableBody>
                {updatesListData?.map((update: any) => {
                  const isItemSelected = isSelected(update.id);
                  return (
                    <TableRow
                      className="table-data-row"
                      hover
                      role="checkbox"
                      selected={isItemSelected}
                    >
                      <TableCell padding="checkbox" style={{ minWidth: 50 }}>
                        <Checkbox
                          onClick={(event) => handleClick(event, update.id)}
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={update.id}
                          className="active-checkbox"
                          checked={isItemSelected}
                        />
                      </TableCell>
                      <TableCell
                        className="table-data-text"
                        style={{ minWidth: 200 }}
                      >
                        <Stack justifyContent="flex-start">
                          {" "}
                          {update.detailedInfo[0].media?.value &&
                          update.detailedInfo[0].media.value ? (
                            <Avatar
                              className={styles["update-image-size-fix"]}
                              src={update.detailedInfo[0].media?.value?.url}
                            ></Avatar>
                          ) : (
                            ""
                          )}
                          {update?.displayTitle.length > 18 ? (
                            <Stack
                              justifyContent="flex-start"
                              sx={{ width: "100%" }}
                            >
                              <span>{`${update?.displayTitle.slice(
                                0,
                                18
                              )}...`}</span>
                              <Typography
                                component="span"
                                variant="body1"
                                color="#2d2d2d"
                                sx={{
                                  fontWeight: "bold",
                                  cursor: "pointer",
                                  wordBreak: "keep-all",
                                  textAlign: "start",
                                  width: "130px",
                                }}
                                onClick={(event: any) =>
                                  popOverComponent(event, update?.displayTitle)
                                }
                              >
                                READ MORE
                              </Typography>
                            </Stack>
                          ) : (
                            update?.displayTitle
                          )}
                        </Stack>
                      </TableCell>

                      <TableCell
                        className="table-data-text"
                        style={{ minWidth: 120 }}
                      >
                        {update.updateType === UpdateTypeValueEnum.HoABL
                          ? UpdateTypeEnum.HoABL
                          : update.updateType === UpdateTypeValueEnum.Project
                          ? UpdateTypeEnum.Project
                          : UpdateTypeEnum.Factual}
                      </TableCell>
                      <TableCell
                        className="table-data-text"
                        style={{ minWidth: 170 }}
                      >
                        <div>
                          {update.createdAt
                            ? format(new Date(update.createdAt), "dd/MM/yyyy")
                            : "-"}
                        </div>
                      </TableCell>
                      <TableCell
                        className="table-data-text"
                        style={{ minWidth: 170 }}
                      >
                        <div>
                          {update.createdAt
                            ? format(new Date(update.createdAt), "dd/MM/yyyy")
                            : "-"}
                        </div>
                      </TableCell>
                      <TableCell
                        className="table-data-text"
                        style={{ minWidth: 170 }}
                      >
                        <div>
                          {update.updatedAt
                            ? format(new Date(update?.updatedAt), "dd/MM/yyyy")
                            : "-"}
                        </div>
                      </TableCell>
                      <TableCell
                        className="table-data-text"
                        style={{ minWidth: 170 }}
                      >
                        {update?.marketingUpdateUpdatedBy?.firstName
                          ? update?.marketingUpdateUpdatedBy?.firstName
                          : "-"}
                      </TableCell>

                      <TableCell
                        className="table-data-text"
                        style={{ minWidth: 120 }}
                      >
                        <PrioritySelector
                          incrementpriority={() => {
                            const priorityRequestBody = {
                              id: update?.id,
                              priority: update?.priority + 1,
                            };
                            blogPriority(priorityRequestBody);
                          }}
                          decrementpriority={() => {
                            const priorityRequestBody = {
                              id: update?.id,
                              priority: update?.priority - 1,
                            };
                            blogPriority(priorityRequestBody);
                          }}
                          priority={update?.priority}
                          disableDecrement={
                            update?.priority == 1 ? true : false
                          }
                          isPriorityRequired={
                            !isSortByPriority ||
                            update?.status == StatusTypeEnumInsight.Inactive
                          }
                        />
                      </TableCell>

                      <TableCell
                        className="table-data-text"
                        style={{ minWidth: 120 }}
                      >
                        {update?.status
                          ? BlogStatusTypeEnumUtils.getEnumText(update?.status)
                          : "-"}
                      </TableCell>

                      <TableCell
                        className="table-data-text"
                        style={{ minWidth: 120 }}
                      >
                        <Tooltip title="Edit" placement="top">
                          <IconButton
                            aria-label="edit"
                            onClick={() => editUpdate(update)}
                          >
                            <ModeEditOutlineOutlinedIcon className="table-action-icon edit-icon" />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="View" placement="top">
                          <IconButton
                            aria-label="view"
                            onClick={() => viewUpdate(update)}
                          >
                            <VisibilityOutlinedIcon className="table-action-icon view-icon" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            ) : (
              <div className="no-record">No Blog Records</div>
            )}
          </Table>
        </TableContainer>

        <ClickAwayListener
          mouseEvent="onMouseDown"
          touchEvent="onTouchStart"
          onClickAway={handleClickAway}
        >
          <Popper open={open} placement="bottom-start" anchorEl={anchor}>
            <ReadmoreDialogWrapper>
              <Paper elevation={3} sx={{ p: "0.5rem", width: "350px" }}>
                {description}
              </Paper>
            </ReadmoreDialogWrapper>
          </Popper>
        </ClickAwayListener>
        {!searchKey && updatesListData && updatesListData.length > 0 ? (
          <TablePagination
            rowsPerPageOptions={[10, 50, 100]}
            component="div"
            count={totalCount ? totalCount : updatesListData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        ) : null}
      </Fragment>
    );
  };
  const isFilterApplied = () => {
    if (
      selectedStatus === "" &&
      selectedUpdatedBy === null &&
      selectedCreatedBy === null &&
      selectPublishedBy === "" &&
      selectedFormType === ""
    ) {
      return false;
    }
    return true;
  };
  const render = () => {
    if (
      (updatesListData?.length > 0 || isFilterApplied() || searchKey !== "") &&
      isLoading === false
    ) {
      return renderTable();
    } else if (
      (updatesListData?.length === 0 ||
        updatesListData?.length === undefined) &&
      !isFilterApplied() &&
      searchKey === "" &&
      isLoading === false
    ) {
      return renderNoData();
    } else if (isLoading) {
      return renderLoader();
    } else if (error) {
      return renderRetry();
    }
  };
  const shouldProvidePlaceholder = () => {
    if (
      (updatesListData?.length === 0 ||
        updatesListData?.length === undefined) &&
      !isFilterApplied() &&
      searchKey === "" &&
      isLoading === false
    ) {
      return false;
    }
    return true;
  };
  return (
    <Fragment>
      <PageHeading title="Blog Management" />
      <BreadCrumbs
        routes={breadcrumbRoutes}
        placeholder={shouldProvidePlaceholder() ? "Search Blog" : ""}
        handleSearchOnKeyPress={handleSearchChange}
      ></BreadCrumbs>

      <Container className="main-container">{render()}</Container>

      <ConfirmationDialog
        shouldOpen={isConfirmDeleteDialogOpen}
        title="Delete Blog?"
        content={`Are you sure that you want to delete the ${selectedUpdate.length} selected blog?`}
        okText="Delete"
        cancelHandler={handleCloseConfirmDialog}
        okHandler={deleteSelectedUpdates}
      />

      {/* <FlashMessageDialog
        shouldOpen={shouldOpenFlashDialog}
        content={isSuccess ? message : error}
        isSuccess={isSuccess}
        cancelHandler={handleCloseFlashMessageDialog}
      /> */}

      {message ? (
        <FlashMessageDialog
          shouldOpen={true}
          content={message ? message : "Something Went Wrong!"}
          isSuccess={true}
          cancelHandler={handleCloseFlashMessageDialog}
        />
      ) : null}

      {error ? (
        <FlashMessageDialog
          shouldOpen={true}
          content={error}
          isSuccess={false}
          cancelHandler={handleCloseFlashMessageDialog}
        />
      ) : null}
    </Fragment>
  );
};

export default BlogList;
